import { useState, useEffect, useRef } from 'react';
import { SavingsPlanType, SavingsPlanTypes } from '../../services/SavingsPlanService';
import SubscriptionService, { SubscriptionType } from '../../services/SubscriptionService';
import DocumentTitle from 'react-document-title';
import Auth from "../../Auth/Auth";
import BackButton from "../buttons/BackButton";
import FirstStepsExperience from './FirstStepsExperience';
import UsersSubscription, { UsersSubscriptionType } from '../../services/UsersSubscriptionService';
import subscriptionService from '../../services/SubscriptionService';
import { getCdnUrl } from '../../utils/Cdn';
import { ModalWithCancel } from '../Modals/ModalWithCancel';
import { DUPLICATED_EMAIL_TITLE, EMAIL_MODAL_MESSAGE_ERROR, validateUserEmail } from '../../utils/Users';

const allowedSubscriptionTypes = ['experience', 'bonification', 'promotion'];
interface INewExperienceSavingsPlanProps
{
    publicVersion: boolean;
}

const NewExperienceSavingsPlan = (props: INewExperienceSavingsPlanProps) =>
{
    const [error, setError] = useState({ message: false });
    const user = Auth.getUserProfile();
    const activeSavingPlan = Auth.getActivePlan();
    const hasValueSubscription = useRef<boolean>(false);
    const [subscription, setSubscription] = useState<SubscriptionType>();
    const [savingsPlanToCopy, setSavingsPlanToCopy] = useState<SavingsPlanType | undefined>();
    const [isLoaded, setIsLoaded] = useState(false);
    const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>(
    {
        userId: user.id ? user.id : null,
        name: "Plan Libertad",
        periodicContribution: 0,
        periodicContributionPeriod: 1,
        type: SavingsPlanTypes.Experience,
        status: 0
    });

      // comprobar email único de usuario
      const [showEmailModal, setShowEmailModal] = useState(false);
      const [emailModalMessage, setEmailModalMessage] = useState(EMAIL_MODAL_MESSAGE_ERROR);



    useEffect(() =>
    {
        if (subscription !== undefined)
        {
            return;
        }

        const subscriptionStoraged = Auth.getExperienceSubscription();

        if (subscriptionStoraged !== null && subscriptionStoraged !== "" && subscriptionStoraged !== undefined)
        {
            SubscriptionService.getSubscription(parseInt(subscriptionStoraged)).then((subscription: SubscriptionType) =>
            {
                setSubscription(subscription);
                setIsLoaded(true);
            },
            (error) =>
            {
                setError(error);
                setIsLoaded(true);
            });
        }
        else
        {
            if (activeSavingPlan.id === null || activeSavingPlan.id === undefined) {
                loadRecommendedSubscription();
                return;
            }

            subscriptionService.getSubscriptionBySavingPlanId(activeSavingPlan.id).then((subscription: any) =>
            {
                if (subscription !== undefined && allowedSubscriptionTypes.includes(subscription.type))
                {
                    UsersSubscription.getUserSubscriptionsByType(user.id, subscription.type).then((usersSubscriptions: UsersSubscriptionType[]) =>
                    {
                        if (usersSubscriptions !== undefined && usersSubscriptions.length > 0)
                        {
                            hasValueSubscription.current = true;
                            setSubscription(usersSubscriptions[0].subscription);
                            if (usersSubscriptions[0].savingsPlans !== null && usersSubscriptions[0].savingsPlans !== undefined && usersSubscriptions[0].savingsPlans[0] !== undefined)
                            {
                                let planSelected = usersSubscriptions[0].savingsPlans[0];
                                if (activeSavingPlan !== null && activeSavingPlan !== undefined)
                                {
                                    planSelected = usersSubscriptions[0].savingsPlans.find(p => p.id === activeSavingPlan.id) ?? planSelected;
                                }
                                setSavingsPlanToCopy(planSelected);
                            }
                            setIsLoaded(true);
                        }
                        else {
                            loadRecommendedSubscription();
                        }
                    });
                }
                else {
                    loadRecommendedSubscription();
                }
            });
        }
    }, []);

    const loadRecommendedSubscription = () =>
    {
        SubscriptionService.getRecommendedSubscription().then((recommendedSubscription: SubscriptionType) =>
        {
            Auth.setExperienceSubscription(recommendedSubscription.id);
            setSubscription(recommendedSubscription);
            setIsLoaded(true);
        },
        error =>
        {
            setError(error);
            setIsLoaded(true);
        });
    };

    const onChangePeriodicQuantity = (event: any) =>
    {
        setSavingsPlan(prevState =>
        ( // @ts-ignore
            { ...prevState, periodicContribution: parseFloat(event.target.value.replace(/[.€]/g, "")) }
        ))
    };

    const onChangeContributionPeriod = (event: any) =>
    {
        setSavingsPlan(prevState =>
        ( // @ts-ignore
            { ...prevState, periodicContributionPeriod: parseFloat(event.target.value) }
        ))
    };

    const handleValidateUserEmail = async (): Promise<boolean> => {
        const { isValid, message } = await validateUserEmail();

        if (!isValid) {
            setEmailModalMessage(message || "");
            setShowEmailModal(true);
            return false;
        }

        return true;
        };

    if(error.message)
    {
        return (<div>Error: {error.message}</div>)
    }

    return(
        <>
            <DocumentTitle title='IronIA - Nuevo plan de cartera'>
                <div>
                    {!props.publicVersion && <BackButton />}
                    <div className="ms-Grid-row savings-plans section-header">
                        <div className="ms-Grid-col ms-md3">
                            <div className="image-experience-container">
                                <img src={getCdnUrl('ihaveexperience.webp')} alt='Cliente con experiencia' />
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-md9">
                            <h2 className="highlighted">Plan Libertad</h2>
                            <p className="description">Utiliza el buscador de fondos para seleccionar tus productos, añádelos al carrito y págalos desde tu banco habitual.</p>
                        </div>
                    </div>
                    <div className="ms-Grid-row savings-plans options">
                        <FirstStepsExperience
                            savingsPlan={savingsPlan}
                            savingsPlanIsCompleted={true}
                            isSavingsPlanReady={isLoaded}
                            user={user}
                            subscription={subscription}
                            savingsPlanToCopy={savingsPlanToCopy}
                            hasValueSubscription={hasValueSubscription.current}
                            publicVersion={props.publicVersion}
                            onChangePeriodicQuantity={onChangePeriodicQuantity}
                            onChangeContributionPeriod={onChangeContributionPeriod}
                            validateUserEmail={handleValidateUserEmail}
                        />
                    </div>
                </div>
            </DocumentTitle>

            <ModalWithCancel
                title={DUPLICATED_EMAIL_TITLE}
                body={emailModalMessage}
                showModal={showEmailModal}
                setShowModal={setShowEmailModal}
                onSubmit={() => setShowEmailModal(false)}
            />
        </>
    );
}

export default NewExperienceSavingsPlan;